import React, { useState, useEffect } from "react"
import Patientinfo from "../../views/welcomevisits/patientinfo"
import Patientform from "../../views/welcomevisits/patientform"
import Corticacenter from "../../views/welcomevisits/corticacenter"
import Caregiverinfo from "../../views/welcomevisits/caregiver"
import Insurance from "../../views/welcomevisits/insurance"
import InsurancePlan from "../../views/welcomevisits/insurancePlan"
import ConsentPage from "views/welcomevisits/consentpage"

const Welcomevisits = () => {
  const [step, setstep] = useState(1)
  const nextStep = () => {
    setstep(step + 1)
  }
  const prevStep = () => {
    setstep(step - 1)
  }

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])
  const [analyticsPayload, setAnalyticsPayload] = useState({
    campaign: "",
    campaignStacking: "",
    gaclientid: "",
    gclid: "",
    medium: "",
    source: "",
  })
  const [user, setUser] = useState({
    address1: "",
    address2: "",
    birthdate: "",
    city: "",
    country: "USA",
    gender: "",
    lastName: "",
    name: "",
    state: "",
    zipCode: "",
    newdatebirth: "",
  })
  const [pationinfo, setPationinfo] = useState({
    previously_diagnosed: "true",
    seeking_diagnoses: "true",
    seeking_evaluation: "true",
  })
  const [careinfo] = useState({
    careinformation: "",
    emergency_contact: "true",
    legal_guardian: "true",
  })
  const [findAFacilityuser, setfindAFacility] = useState({
    findAFacility: "",
    leadSource: "",
  })
  const [careuser, setcareUser] = useState({
    address1: "",
    address2: "",
    city: "",
    country: "USA",
    check: false,
    emailAddress: "",
    lastName: "",
    name: "",
    phoneNumber: "",
    primary_caregiver: "true",
    state: "",
    zipCode: "",
  })
  const [insuranceuser, setinsuranceUser] = useState({
    address1: "",
    address2: "",
    checkbox: "",
    city: "",
    check: false,
    country: "USA",
    emailAddress: "",
    lastName: "",
    name: "",
    phoneNumber: "",
    state: "",
    zipCode: "",
  })
  const [insuranceplan, setinsuranceplan] = useState({
    insurance_name: "",
    insurance_phone: "",
    member_number: "",
    group_number: "",
    plan_coverage: "PPO",
    plan_name: "",
  })
  switch (step) {
    case 1:
      return (
        <div className="App">
          <ConsentPage nextStep={nextStep} />
        </div>
      )
    case 2:
      return (
        <div className="App">
          <Patientinfo
            nextStep={nextStep}
            setUser={setPationinfo}
            user={pationinfo}
          />
        </div>
      )
    // case 2 to show stepTwo form passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the fprm
    case 3:
      return (
        <div className="App">
          <Patientform
            analyticsPayload={analyticsPayload}
            nextStep={nextStep}
            prevStep={prevStep}
            setAnalyticsPayload={setAnalyticsPayload}
            setUser={setUser}
            user={user}
          />
        </div>
      )
    // Only formData is passed as prop to show the final value at form submit
    case 4:
      return (
        <div className="App">
          <Corticacenter
            nextStep={nextStep}
            prevStep={prevStep}
            setUser={setfindAFacility}
            user={findAFacilityuser}
          />
        </div>
      )
    case 5:
      return (
        <div className="App">
          <Caregiverinfo
            nextStep={nextStep}
            pationuser={user}
            prevStep={prevStep}
            setUser={setcareUser}
            user={careuser}
          />
        </div>
      )
    case 6:
      return (
        <div className="App">
          <Insurance
            careuser={careuser}
            nextStep={nextStep}
            pationuser={user}
            prevStep={prevStep}
            setUser={setinsuranceUser}
            user={insuranceuser}
          />
        </div>
      )
    case 7:
      return (
        <div className="App">
          <InsurancePlan
            apiData={{
              analyticsPayload: analyticsPayload,
              careinfo: careinfo,
              careuser: careuser,
              findAFacilityuser: findAFacilityuser,
              insuranceplan: insuranceplan,
              insuranceuser: insuranceuser,
              pationinfo: pationinfo,
              user: user,
            }}
            nextStep={nextStep}
            prevStep={prevStep}
            setUser={setinsuranceplan}
            user={insuranceplan}
          />
        </div>
      )

    case 8:
      return (
        <div className="App">
          <h1>hello</h1>
        </div>
      )
    // default case to show nothing
    default:
      return <div className="App"></div>
  }
}
export default Welcomevisits
